<template>
  <b-modal
    modal-class="mc-modal-link"
    id="modal-link"
    :title="$t('fleetTask.share.title') + ' ' + detailData.number"
    size="md"
    centered
    scrollable
  >
    <p class="mc-paragraph">{{ $t('fleetTask.share.text') }}</p>
    <b-list-group class="mc-general__label">
      <b-list-group-item href="#" @click="copyLink">
        <i class="mc-icon fas fa-link me-1"></i>
        <span class="mc-general__label">{{ $t('global.action.copyLink') }}</span>
      </b-list-group-item>
      <b-list-group-item href="#" @click="redirect">
        <i class="mc-icon icon-outline_map me-1"></i>
        <span class="mc-general__label">{{ $t('global.action.share.viewTracking') }}</span>
      </b-list-group-item>
    </b-list-group>

    <template #modal-footer="{ cancel }">
      <b-button size="md" variant="outline-primary" @click="cancel()">
        {{ $t('global.action.cancel') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { MixPanel } from '@/mixin/mixpanel'

export default {
  mixins: [MixPanel],
  props: {
    detailData: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  methods: {
    copyLink() {
      this.track('FO TMS Copy Link Clicked')

      navigator.clipboard.writeText(this.detailData.track_link)
      this.$mcToast.success(this.$t('fleetTask.share.success'))
      this.$bvModal.hide('modal-link')
    },
    redirect() {
      const url = this.detailData.track_link
      window.open(url, '_blank')
      this.$bvModal.hide('modal-link')
    },
  },
}
</script>
